import * as React from "react";
import CheckIcon from "@mui/icons-material/Check";
import LogoWithText from "../upsolver-images/logos/upsolver-with-text-blue.svg";

import useBodyClass from "../core/useBodyClass";
import { PlanTypeClazz } from "../core/api/contracts/Organization";

import "../signup.scss";

export interface Content {
  header: string;
  specs: string[];
}

interface SignUpBoxProps {
  plan?: PlanTypeClazz;
  contentDetails?: Content[];
}

const FREE: Content[] = [
  {
    header: "Free forever with your Community license",
    specs: [
      "Full functionality of Upsolver: ingest, process and deliver data",
      "Design and run stream processing jobs using SQL or a visual UI",
      "20 GB storage",
      "Sandbox Query environment",
    ],
  },
  {
    header: "Connect your Cloud account for",
    specs: [
      "Unlimited storage on your account",
      "Premium support in first 30 days",
      "Guided proof-of-concept (optional)",
    ],
  },
];
const FREE_HEADER: string = "The Upsolver Community Edition is Free";

const TRIAL: Content[] = [
  {
    header: "Experience the power of Upsolver in a fully-featured 14 day trial",
    specs: [
      "Full functionality of Upsolver: ingest, process and deliver data",
      "Design and run stream processing jobs using SQL or a visual UI",
      "Unlimited storage on your account",
      "Premium support",
      "Guided proof-of-concept (optional)",
    ],
  },
];

const TRIAL_HEADER: string = "Create your free Upsolver account. No credit card required";

function SignUpBox({ plan, children, contentDetails }: React.PropsWithChildren<SignUpBoxProps>) {
  useBodyClass("signup-body");

  const content = React.useMemo(() => {
    if (contentDetails) {
      return { details: contentDetails, header: "" };
    }
    if (plan === "FreePlanRequest") {
      return { details: FREE, header: FREE_HEADER };
    } else {
      return { details: TRIAL, header: TRIAL_HEADER };
    }
  }, [plan]);

  return (
    <div className="signup">
      <div className="create">
        <div>
          <img src={LogoWithText} alt="Upsovler-Logo" />
          <h1 className="main">{content.header}</h1>
          <h1>Get started in minutes</h1>
          {children}
        </div>
      </div>
      <div className="details">
        {content.details.map((section, index) => (
          <div className="detail-item" key={index}>
            <header>{section.header}</header>
            {section.specs.map((spec, index) => (
              <section key={index}>
                <CheckIcon />
                <span>{spec}</span>
              </section>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export { SignUpBox };
